<template>
  <div>
    <h3>Push server info</h3>

    <template v-if="info !== null">
      <table class="props-compact mb-4">
        <tr>
          <th>Time</th>
          <td>{{info.time | getMomentStr}}</td>
        </tr>
        <tr>
          <th>Hostname</th>
          <td>{{info.hostname}}</td>
        </tr>
        <tr>
          <th>Revision hash</th>
          <td>{{info.revisionHash}}</td>
        </tr>
      </table>

      <h4 class="mb-1">Redis connection conf</h4>
      <redis-connection-conf-view :conf="info.redisConnectionConf"/>

      <hr>

      <table class="props-compact">
        <tr>
          <th>Active push amount</th>
          <td>{{info.activePushAmount}}</td>
        </tr>
      </table>

      <hr>

      <h4 class="mb-1">Uptrace conf</h4>
      <table class="props-compact mb-4">
        <tr>
          <th>Uptrace on</th>
          <td>{{info.uptraceInfo.uptraceOn}}</td>
        </tr>
        <tr>
          <th>Uptrace DSN</th>
          <td>{{info.uptraceInfo.uptraceDSN}}</td>
        </tr>
        <tr>
          <th>Service name</th>
          <td>{{info.uptraceInfo.serviceName}}</td>
        </tr>
        <tr>
          <th>Service version</th>
          <td>{{info.uptraceInfo.serviceVersion}}</td>
        </tr>
        <tr>
          <th>Environment</th>
          <td>{{info.uptraceInfo.deploymentEnvironment}}</td>
        </tr>
      </table>

      <hr>

    </template>

    <loading-indicator
      v-if="isLoading"
    />
  </div>
</template>

<script>
import { HTTP } from '../http-common.js';
import notifier from '../notifier.js';

import LoadingIndicator from './LoadingIndicator.vue';
import RedisConnectionConfView from './RedisConnectionConfView.vue';

const LOAD_STATE_INIT          = 1;
const LOAD_STATE_LOADING       = 2;
const LOAD_STATE_LOADED_NORMAL = 3;
const LOAD_STATE_LOADED_ERROR  = 4;

export default {
  name: 'SystemInfoPushServer',

  components: {
    LoadingIndicator,
    RedisConnectionConfView,
  },

  data() {
    return {
      loadState: LOAD_STATE_INIT,

      info: null,
    };
  },

  computed: {
    isLoading() {
      return this.loadState === LOAD_STATE_LOADING;
    },
  },

  created() {
    this.loadInfo();
  },

  methods: {
    loadInfo() {
      notifier.deleteSenderNotifications(this);

      this.loadState = LOAD_STATE_LOADING;

      HTTP.get('/push_server_info')
      .then(response => {
        this.info = response.data.data;
        this.loadState = LOAD_STATE_LOADED_NORMAL;
      })
      .catch(e => {
        this.loadState = LOAD_STATE_LOADED_ERROR;
        notifier.showError(e.response.data, {sender: this});
      });
    },
  },
};
</script>
